export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#fff', '#fff'],
        home_question: ['#fff', '#fff'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '0rem',
        photo: '0rem',
        textField: '0rem !important',
    },
    shadows : {
        default: 'none',
        home_question: 'none'
    },

    agendaStyle : {
        headerColor: '#EA4D95',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#2e1344',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#EA4D95',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#2e1344'
    },

    primary: '#fff',
    secondary: '#263238',
    accent: '#fff',
    text: '#fff',
    buttonText: {
        home_question: '#000',
        default: '#000'
    },
    background:"#db1000",

    homeQuestionIcon: false,

    poll:{
        default:"#fff",
        answered:"#e02307",
        correct: '#3A722D',
        wrong: '#a41306'
    },
    pollBorder: {
        default:"#fff",
        answered:"#fff",
        correct: '#3A722D',
        wrong: '#a41306'
    },
    pollTextColor: {
        default:"#000",
        answered:"#fff",
        correct: '#fff',
        wrong: '#fff'
    }
}